import React, { useEffect, useState } from "react";
import { Form, Input, Tag, Select, Checkbox, Radio, Avatar, InputNumber, Rate, DatePicker, message } from 'antd';
import { FacebookOutlined, TwitterOutlined, YoutubeFilled, InstagramOutlined, ExceptionOutlined, WhatsAppOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import GooglePay from '../assets/images/GooglePay.svg';
import MasterCard from '../assets/images/Mastercard.svg';
import Visa from '../assets/images/visa-logo.svg';
import UPI from '../assets/images/UPI.svg';
import Easebuzz from '../assets/images/easebuzz_logo.svg';
import BellLogo from '../assets/images/bell_logo.svg';
import { COUNTRY_CODES } from "../services/countryCodes";
import { axiosInsPaymentLinks } from "../services/axios"

const { TextArea } = Input;
const { Option } = Select;

const FEEDBACK_DISABLED = ['QuantityNumberInput']

const RenderIcon = ({ option, ...rest }) => {
    let mapping = {
        "facebook": <FacebookOutlined {...rest} />,
        "instagram": <InstagramOutlined {...rest} />,
        "youtube": <YoutubeFilled {...rest} />,
        "twitter": <TwitterOutlined {...rest} />,
        "whatsapp": <WhatsAppOutlined {...rest} />,
        "error": <ExceptionOutlined {...rest} />
    }
    return mapping[option] || mapping["error"];
}

const ChildMapper = (values, type) => {

    const options =
        values !== undefined ?
            values.map((option, i) => {
                switch (type) {
                    case "select":
                        return (
                            <Option key={i} value={option}>
                                {option}
                            </Option>
                        );
                    case "submerchant_select":
                        return (
                            <Option key={option} value={option}>
                                {option.split("-")[1]}
                            </Option>
                        );
                    case "radio":
                        return (
                            <Radio.Button key={i} value={option}>
                                {option}
                            </Radio.Button>
                        );
                    case "checkbox":
                        return (
                            <Checkbox key={i} value={new Array(option)}>
                                {option}
                            </Checkbox>
                        );
                    case "tags":
                        return (
                            <Tag key={i} value={option}>
                                {option}
                            </Tag>
                        )
                    case "socialtags":
                        if (option && option.match(/(instagram|facebook|youtube|whatsapp)/g)) {
                            let props = {
                                option: option.match(/(instagram|facebook|youtube|whatsapp)/g)[0] || null,
                                style: { fontSize: 25, marginLeft: 10, cursor: 'pointer' },
                                onClick: () => { window.open(option) },
                            }
                            return <RenderIcon  {...props} />
                        }
                        return null;
                    default:
                        return null;
                }
            })
            : null;
    return options;
}

const FieldMapper = (props) => {
    let style = props.cssConfig || {};
    let optionalRules = {}
    let submerchant_list = []
    if (props.field.type === "SubmerchantDropDown") {
        let active_submerchants = props.active_submerchants.map(option => `${option.submerchant_id} - ${option.name}`)
        submerchant_list = props.active_submerchants ? active_submerchants.filter((submerchant) => !props.field.options.includes(submerchant)) : [];
    }
    if (props.field.type === "MultiRegionPhoneNumberInputField") {
        optionalRules['pattern'] = new RegExp(/^[0-9]{7,11}$/);
    }
    else {
        if (props.field.regex !== undefined && props.field.regex !== "") {
            optionalRules['pattern'] = new RegExp(props.field.regex);
        }
    }
    let formItemProps = {
        validateTrigger: ['onChange', 'onBlur'],
        fieldKey: [props.formField.fieldKey, 'value'],
        name: [props.formField.name, 'value'],
        hasFeedback: !FEEDBACK_DISABLED.includes(props.field.type),
        labelCol: props.labelCol,
        wrapperCol: props.wrapperCol,
        label: props.field.alias,
        required: props.field.end_user_mandatory,
        initialValue: props.field.default_value,
        colon: false,
        rules: [
            {
                required: props.field.end_user_mandatory,
                message: props.field.error_message,
                ...optionalRules,
            }
        ],
        style: props.field.style !== undefined ? props.field.style : { ...style.formItemStyle },
        labelAlign: "left",
        extra: props.end_user_input ? props.field.description : null,
    }

    const QuantityNumberInput = (props) => {
        const [quantity, setQuantity] = useState(props.field.min_value);
        const [value, setValue] = useState(props.field.default_value * props.field.min_value);

        useEffect(() => {
            props.onChange(quantity)
            setValue(prev => parseFloat(quantity * props.field.default_value).toFixed(2));
        }, [quantity])

        const handleOperations = (e, type, ) => {
            e && e.preventDefault();
            const operations = {
                '+': () => { 
                    if(value && (quantity + 1 <= props.field.max_value)){
                        setQuantity(prev => prev + 1);
                    }
                    else{
                        message.info(`Maximum quantity limit exceeded - ${props.field.max_value}`);
                    }
                    
                },
                '-': () => {
                    if(value && (quantity - 1 >= props.field.min_value)){
                        setQuantity(prev => prev - 1);
                    }else{
                        message.info(`Minimum order value needs to be satisfied - ${props.field.min_value}`);
                    }
                }
            }
            operations[type]();
        }
        return (
            <Form.Item name={[props.formField.name, 'quantity']} fieldKey={[props.formField.fieldKey, 'quantity']}>
                <Input 
                    style={{width: '40%'}}
                    value={value} 
                    disabled={true}
                />
                <Input
                    style={{width: '60%'}}
                    addonBefore={<PlusOutlined onClick={(e) => handleOperations(e, '+')} />}
                    addonAfter={<MinusOutlined onClick={(e) => handleOperations(e, '-')} />}
                    value={quantity}
                />
            </Form.Item>
        )
    }

    const handlePrefix = <Form.Item name={[props.formField.name, "prefix"]} initialValue={"+91"} noStyle><Select showSearch style={{ width: 80 }}>{COUNTRY_CODES.map((country, index) => <Option key={country.dial_code}>{country.dial_code}</Option>)}</Select></Form.Item>

    switch (props.field.type) {
        case "LabelField": return <Form.Item {...formItemProps}>{props.labelData !== undefined && props.labelData[props.field.name] !== undefined ? props.labelData[props.field.name] : props.field.default_value}</Form.Item>
        case "InputField": return props.field.end_user_input ? <Form.Item {...formItemProps}><Input /></Form.Item> : <Form.Item {...formItemProps}>{props.field.default_value}</Form.Item>
        case "EmailField": return props.field.end_user_input ? <Form.Item {...formItemProps}><Input /></Form.Item> : <Form.Item {...formItemProps}>{props.field.default_value}</Form.Item>
        case "PanInputField": return <Form.Item {...formItemProps}><Input /></Form.Item>;
        case "DropDown": return <Form.Item {...formItemProps}><Select>{ChildMapper(props.field.options, 'select')}</Select></Form.Item>
        case "SubmerchantDropDown": return <Form.Item {...formItemProps}><Select allowClear={true} showSearch={true} filterOption={(input, option) => option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0}>{ChildMapper(submerchant_list, 'submerchant_select')}</Select></Form.Item>;
        case "RadioBox": return <Form.Item {...formItemProps}><Radio.Group>{ChildMapper(props.field.options, 'radio')}</Radio.Group></Form.Item>
        case "CheckBox": return <Form.Item {...formItemProps}><Checkbox.Group options={props.field.options}></Checkbox.Group></Form.Item>
        case "NumberField": return props.field.end_user_input ? <Form.Item {...formItemProps}><InputNumber style={{width: "100%"}}/></Form.Item> : <Form.Item {...formItemProps}>{props.field.default_value}</Form.Item>
        case "UserNumberInput": return <Form.Item {...formItemProps}><InputNumber min={1} max={100000000} style={{width: "100%"}}/></Form.Item>
        case "FixedNumberInput": return <Form.Item {...formItemProps}>{props.field.default_value}</Form.Item>
        case "QuantityNumberInput": return <Form.Item {...formItemProps}><QuantityNumberInput {...props} /></Form.Item>
        case "TextArea": return props.field.end_user_input ? <Form.Item {...formItemProps}><TextArea /></Form.Item> : <Form.Item {...formItemProps}>{props.field.default_value}</Form.Item>
        case "DatePicker": return <Form.Item {...formItemProps}><DatePicker style={{width:"100%"}}/></Form.Item>
        case "RatePicker": return <Form.Item {...formItemProps}><Rate className="custom-rate-picker" allowHalf /></Form.Item>
        case "Tags": return <Form.Item {...formItemProps}>{ChildMapper(props.field.options, 'tags')}</Form.Item>
        case "Avatar": return <Form.Item {...formItemProps}><Avatar size={200} shape="square" /></Form.Item>
        case "SocialMediaHandler": return <Form.Item {...formItemProps}>{ChildMapper(props.field.options, 'socialtags')}</Form.Item>;
        case "PhoneNumberInputField": return <Form.Item {...formItemProps}><Input /></Form.Item>;
        case "MultiRegionPhoneNumberInputField": return <Form.Item {...formItemProps}><Input addonBefore={handlePrefix} /></Form.Item>;
        default: return <Form.Item {...formItemProps}><Input /></Form.Item>
    }
}

const DynamicForm = React.forwardRef((props, ref) => {

    const [form] = Form.useForm();
    let formProps = {
        ref: ref,
        form: form,
        requiredMark: false,
        style: props.formCss,
    }
    return (
        <Form {...formProps}>
            <Form.List name="dynamic_form" initialValue={props.fields}>
                {(fields, { add, remove }) => {
                    return (
                        <>
                            {fields.map((field, index) => (
                                <FieldMapper key={index} formField={field} field={props.fields[index]} active_submerchants={props.active_submerchants} cssConfig={props.cssConfig} labelData={props.labelData} labelCol={props.labelCol} wrapperCol={props.wrapperCol} form={form} />
                            ))}
                        </>
                    )
                }}
            </Form.List>
        </Form >
    )
})

class SmartPayUtil {
    constructor(smart_pay) {
        this.id = smart_pay.id || null;
        this.link_name = smart_pay.link_name || null;
        this.merchant_name = smart_pay.merchant_name || null;
        this.merchant_logo = smart_pay.merchant_logo || null;
        this.payment_url_suffix = smart_pay.payment_url_suffix || '';
        this.is_active = smart_pay.is_active || false;
        this.submerchant_id = smart_pay.submerchant_id || null;
        this.split_payments = smart_pay.split_payments || null;
        this.settings = {
            id: smart_pay.settings.id || null,
            display_config: smart_pay.settings.display_config,
            communication_config: smart_pay.settings.communication_config,
            analytics_config: smart_pay.settings.analytics_config,
            reminder_config: smart_pay.settings.reminder_config,
            is_redirection_enabled: smart_pay.settings.is_expiry_date_enabled,
            is_hosted_checkout: smart_pay.settings.is_hosted_checkout,
            redirection_furl: smart_pay.settings.redirection_furl,
            redirection_surl: smart_pay.settings.redirection_surl,
            is_expiry_date_enabled: smart_pay.settings.is_expiry_date_enabled,
            expiry_date: smart_pay.settings.expiry_date,
        }
    }

    set link_status(status) {
        this.is_active = status;
    }

    set page_header_fields(page_header_fields) {
        this.settings.display_config.pre_payment_page.page_header.content.fields = page_header_fields;
    }

    get page_header_fields() {
        return this.settings.display_config.pre_payment_page.page_header.content.fields;
    }

    set page_body_fields(page_body_fields) {
        this.settings.display_config.pre_payment_page.page_body.content.fields = page_body_fields;
    }

    set page_title(title) {
        this.settings.display_config.pre_payment_page.page_header.content.fields.map((field) => {
            if (field.name === "title") {
                field.value = title;
            }
            return field;
        })
    }

    get page_title() {
        return this.settings.display_config.pre_payment_page.page_header.content.fields.filter((field) => {
            if (field.name === "title") {
                return field;
            }
            return null
        })[0];
    }

    set page_description(description) {
        this.settings.display_config.pre_payment_page.page_header.content.fields.map((field) => {
            if (field.name === "description") {
                field.value = description;
            }
            return field;
        })
    }

    get page_description() {
        return this.settings.display_config.pre_payment_page.page_header.content.fields.filter((field) => {
            if (field.name === "description") {
                return field
            }
            return null;
        })[0];
    }

    get page_body_fields() {
        return this.settings.display_config.pre_payment_page.page_body.content.fields;
    }

    set page_footer_fields(page_footer_fields) {
        this.settings.display_config.pre_payment_page.page_footer.content.fields = page_footer_fields;
    }

    get page_footer_fields() {
        return this.settings.display_config.pre_payment_page.page_footer.content.fields;
    }

    set setting_fields(fields) {
        Object.assign(this.settings, fields);
    }

    convert_fields_to_json_string = () => {
        this.link_name = this.settings.link_name;
        this.payment_url_suffix = this.settings.payment_url_suffix;
        this.is_active = this.settings.is_active;
        this.settings.display_config = JSON.stringify(this.settings.display_config);
        this.settings.communication_config = JSON.stringify({});
        this.settings.analytics_config = JSON.stringify({});
        this.settings.reminder_config = JSON.stringify({});
    }

    convert_json_to_fields = () => {
        this.settings.display_config = JSON.parse(this.settings.display_config);
        this.settings.communication_config = JSON.parse(this.settings.communication_config);
        this.settings.analytics_config = JSON.parse(this.settings.analytics_config);
        this.settings.reminder_config = JSON.parse(this.settings.reminder_config);
    }

}

const ASSETS_URL = {
    'pci_dss': process.env.REACT_APP_PAY_URL + 'static/gateway/images/certificates/pcidss.png',
    'visa': process.env.REACT_APP_PAY_URL + 'static/gateway/images/certificates/visa_card.png',
    'master': process.env.REACT_APP_PAY_URL + 'static/gateway/images/certificates/MasterCard_Logo.png',
    'rupay': process.env.REACT_APP_PAY_URL + 'static/gateway/images/certificates/rupay_icon.png',
    'american_express': process.env.REACT_APP_PAY_URL + 'static/gateway/images/certificates/dls-logo-bluebox-solid.svg',
    'easebuzz': process.env.REACT_APP_PAY_URL + 'static/gateway/images/certificates/poweredbyeasebuzz.png',
    'easebuzz_local': Easebuzz,
    'easebuzz_bell_local': BellLogo,
    'google_pay_local': GooglePay,
    'visa_local': Visa,
    'master_card_local': MasterCard,
    'upi_local': UPI,
}

const PayButton = (props) => {
    const { text, handleOnClick, showArrow = true, isPreMobile, isCustomStyle=false, styles={} } = props
    const ShowArrowElement = (elepProps) => {
        const { isRender } = elepProps
        if (isRender) {
            return (
                <div className={isPreMobile ? "pre-buttonaction" : "buttonaction"}>
                    <svg
                        width={isPreMobile ? "30" : "24"}
                        height={isPreMobile ? "30" : "24"}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M23.0677 11.9929L18.818 7.75739L17.4061 9.17398L19.2415 11.0032L0.932469 11.0012L0.932251 13.0012L19.2369 13.0032L17.4155 14.8308L18.8321 16.2426L23.0677 11.9929Z"
                            fill="currentColor"
                        />
                    </svg>
                </div>
            )
        }
        return null
    }
    return (
        <div className={isPreMobile ? 'pre-checkoutButton' : "checkoutButton"}>
            {!isPreMobile ? <div className="payment-section">
            </div> : null}
            <button onClick={handleOnClick} className={isPreMobile ? "pre-pay-now" : !isCustomStyle ? "pay-now" : ""} style={isCustomStyle ? styles : {}}>
                <span>{text}</span>
                <ShowArrowElement isRender={showArrow} />
            </button>
        </div>
    )
}

const EasebuzzFooter = ({ footerImage, merchantDetails, showTerms = false }) => {
    return (
        <>
            {/* <div className="smart-payment-block">
                <div className="smart-payment-footer-info">
                    <p><MailOutlined />  support@easebuzz.in</p>
                    <p><PhoneOutlined />  1800 891 8297 (Toll-free) </p>
                </div>
            </div> */}
            <div className="smart-payment-block">
                <span className={footerImage.styleClass}>
                    {new Date().getFullYear()} - <a href="https://easebuzz.in" style={{ marginRight: 10 }}>Easebuzz </a> | © All rights reserved
                </span>
            </div>
            {showTerms ?
                <div className="smart-payment-block">
                    <span className="smart-payment-terms">
                        You agree to share information entered on this page with {merchantDetails.merchant_name} (owner of this page) and Easebuzz, adhering to applicable laws.
                    </span>
                </div>
                :
                null
            }
        </>
    )
}

var base64ToPDF = (base64String, fileName = "file.pdf") => {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(blobUrl); // cleanup
}

var fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(",")[1]);
  reader.onerror = reject;
  reader.readAsDataURL(file);
})

var generatePDFDownloader = (url, queryData, filename, isDownloadRequired = true, blobFileType="application/pdf") => axiosInsPaymentLinks({
    url: url,
    method: 'post',
    responseType: 'blob',
    data: queryData,
}).then((response) => {
    if (response.status === 200 && response.data.type === blobFileType) {
        const url = window.URL.createObjectURL(new Blob([response.data]), { type: blobFileType });
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        if (isDownloadRequired)
            link.click();
        return url;
    } else {
        const data = new Blob([response.data], { type: "application/json" });
        const reader = new FileReader();
        reader.onload = () => {
            let error = JSON.parse(reader.result);
            message.warning(error.error);
        }
        reader.readAsText(data);
    }
}, (error) => {
    const data = new Blob([error.data], { type: "application/json" });
    const reader = new FileReader();
    reader.onload = () => {
        let error = JSON.parse(reader.result);
        message.warning(error.error_desc);
    }
    reader.readAsText(data);
});

const DEFAULT_CUSTOMIZATION_CONFIG = {
    logo: {
        required: true,
        styles: {},
    },
    name: {
        required: true,
        styles: {},
    }
}

EasebuzzFooter.defaultProps = {
    footerImage: {
        styleClass: '',
    },
    showTerms: false,
    merchantDetails: {
        merchant_name: 'NA',
    }
}

DynamicForm.defaultProps = {}

export { DynamicForm, SmartPayUtil, PayButton, ASSETS_URL, EasebuzzFooter, DEFAULT_CUSTOMIZATION_CONFIG, generatePDFDownloader, base64ToPDF, fileToBase64 };